import { Component, Input } from '@angular/core';
import { LabelForDirective } from 'app/shared/form-utils/label-for.directive';


@Component({
    selector: 'form-row',
    imports: [
        LabelForDirective,
    ],
    host: {
        class: 'form-group row',
    },
    styles: [
        `
        .col-form-label {
            font-weight: bold;
        }
        `
    ],
    template: `
        <label class="col-3 col-form-label" [for]="forId">{{ label }}</label>
        <div class="col-9">
            <ng-content></ng-content>
        </div>
    `,
})
export class FormRowComponent {

    @Input() label: string;

    @Input('for') forId: string;
}
